<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
    data() {
        return {
            swiperOptions: {
                slidesPerView: auto,
                autoHeight: true,
                spaceBetween: 25,
                centeredSlides: false,
                loop: this.loop,
                autoplay: { delay: 20 },
                // breakpoints: {
                //     320: {
                //         slidesPerView: this.colsXs,
                //     },
                //     480: {
                //         slidesPerView: this.colsXs,
                //     },
                //     768: {
                //         slidesPerView: this.colsSm,
                //     },
                //     992: {
                //         slidesPerView: this.colsMd,
                //     },
                //     1200: {
                //         slidesPerView: this.colsLg,
                //     },
                // },
            },
        };
    },

    props: {
        heading: {
            type: String,
        },
        description: {
            type: String,
        },
        postData: {
            type: Array,
            default: function () {
                return [];
            },
        },
        cols: {
            type: Number,
            default: 5,
        },
        colsXs: {
            type: Number,
            default: 5,
        },
        colsSm: {
            type: Number,
            default: 5,
        },
        colsMd: {
            type: Number,
            default: 5,
        },
        colsLg: {
            type: Number,
            default: 5,
        },
        loop: {
            type: Boolean,
            default: true,
        },
        buttonLabel: {
            type: String,
        },
        buttonUrl: {
            type: String,
        },
    },

    computed: {
        swiper() {
            return this.$refs.cardsSwiper.swiper;
        },
    },

    watch: {},

    methods: {
        imageForPost: function (post) {
            if (post.featured_image == null) {
                return "";
            }
            return post.featured_image.thumbnail;
        },
    },

    components: {
        swiper,
        swiperSlide,
    },

    created() {},

    destroyed() {},

    mounted() {
        var self = this;

        setTimeout(function () {
            // Triggering an update after 0.5s to make sure the views are properly spaced according to
            // the current window size. This shouldn't really be necessary but occasionally I have found
            // the rendering is slightly off until the window is resized, so just making sure.
            self.swiper.update();
        }, 500);
    },
};
</script>

<style></style>

<template>
    <div class="brands-slider">
        <div class="brands-slider__body">
            <swiper :options="swiperOptions" ref="cardsSwiper">
                <swiper-slide v-for="post in postData" v-bind:key="post.id">
                    <h3>{{ post.text }}</h3>
                </swiper-slide>
            </swiper>
        </div>
    </div>
</template>
